// Small labels for the "which session do I log out?" list.

/** With the seconds, to tell apart sessions that started in the same minute: "2026-10-14T20:50:12.345" -> "2026-10-14 20:50:12". */
export function fullTime(iso) {
  return iso ? String(iso).replace("T", " ").slice(0, 19) : "-";
}

/** The end of a session id (its start looks alike for every session), so two look-alike rows can be told apart. */
export function shortSessionId(id) {
  return id ? String(id).slice(-5) : "";
}
